import { memo } from 'react'
import { useAccountContext } from '../../contexts/account-context'
import { useRecoilValue } from 'recoil'
import { accountUserIdsState } from '../../states/account-user-ids-state'
import { AccountUsersItem } from './account-users-item'

interface Props {}

const Component = (props: Props) => {
  const accountId = useAccountContext()
  const userIds = useRecoilValue(accountUserIdsState(accountId)) || []
  const isListEmpty = userIds.length === 0

  let content = <div>No users yet</div>

  if (!isListEmpty) {
    content = (
      <table className="table table-compact table-zebra w-full mb-4">
        <thead>
          <tr>
            <th>User</th>
          </tr>
        </thead>
        <tbody>
          {userIds.map((item) => (
            <AccountUsersItem userId={item.userId} />
          ))}
        </tbody>
      </table>
    )
  }

  return <div>{content}</div>
}

export const AccountUsersTable = memo(Component)